import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AppConfig from "../../../../../config/AppConfig";
import {AppIconThumbnail} from "../../../../../components/BaseComponents/AppIconThumbnail";

export default class TimeoffRequestListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getStatusLabel = status => {
        switch (status) {
            case "approved":
                return {label: "Approvato", className: "badge badge-success"};
            case "rejected":
                return {label: "Rifiutato", className: "badge badge-danger"};
            case "waiting_approval":
            default:
                return {label: "In attesa", className: "badge badge-warning"};
        }
    }

    handleOpenClick = _ => {
        if (this.props.onOpen) {
            this.props.onOpen(this.props.item);
        }
    }

    render() {
        const item = this.props.item || {};
        const statusInfo = this.getStatusLabel(item.status);
        const formattedDate = item.date ? moment(item.date).format("DD/MM/YYYY") : "-";
        const timeRange = item.start_time && item.end_time ? `${item.start_time} - ${item.end_time}` : "-";
        const negozio = this.props.staff?.negozio || null;
        const negozioIconUrl = negozio?.id_negozio
            ? `${AppConfig.webServerUrl}/api/negozio/${negozio.id_negozio}/logoIcon/50`
            : null;
        return (
            <div className={"list-group-item list-group-item-action"} onClick={this.handleOpenClick}>
                <div className={"d-flex justify-content-between align-items-start"}>
                    <div className={"d-flex align-items-center"}>
                        <AppIconThumbnail size={"32px"} src={negozioIconUrl} className={"mr-2"}/>
                        <div className={"font-weight-bold"}>{negozio?.nome || "Attivita'"}</div>
                    </div>
                    <span className={statusInfo.className}>{statusInfo.label}</span>
                </div>
                <div className={"text-muted small mt-1"}>
                    {formattedDate} &nbsp; {timeRange}
                </div>
            </div>
        );
    }
}

TimeoffRequestListItem.propTypes = {
    item: PropTypes.object,
    staff: PropTypes.object,
    onOpen: PropTypes.func
};
